document.addEventListener('DOMContentLoaded', function() {
  // Funktion zum Scrollen zum Produkt-Media-Element
  function scrollToProductMedia() {
    var productMedia = document.getElementById('scroll-trigger');
    if (productMedia) {
      productMedia.scrollIntoView({ behavior: 'smooth' }); // Sanftes Scrollen
    }
  }

  // Nur die erste Liste auf der Seite selektieren
  var firstList = document.querySelector('.mw-variant_select');
  
  // Überprüfen, ob die Liste existiert
  if (firstList) {
    var selectOptions = firstList.querySelectorAll('.js-option');
    
    selectOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        var selectedValue = option.dataset.value;
        
        // Zuerst zum Produkt-Media-Element scrollen
        scrollToProductMedia();
        
        // Danach einen kurzen Moment warten und die Seite neu laden
        setTimeout(function() {
          window.location.reload();
        }, 1000); // Verzögerung von 1 Sekunden, damit das Scrollen abgeschlossen ist
      });
    });
  }
});
